<template>
  <div id="alltask" class="tab-cnt tasklist">
    <div class="total-task" v-if="allTaskList.length">
      <span>{{totalTask}}</span>
      {{$t('taskAvailable')}}
    </div>
    <div class="total-task" v-else>
      <span>0</span>
      {{$t('taskAvailable')}}
    </div>
    <ul>
      <li v-for="(task,index) in allTaskList"
        :key="index" @click="goToDetail(task.Task_id, task.task_fam)">
        <div class="item-icon">
          <img :src="require('../assets/images/task-note.svg')" alt />
        </div>
        <div class="task-info">
          <h2>{{task.title}}</h2>
          <p
            v-if="task.delivery_time"
          >{{$t('taskCompletionTime')}} : {{ task.delivery_time.slice(0, task.delivery_time.indexOf('T')) }}</p>
          <p>Rs. {{task.payment}} {{$t('perTask')}}</p>
          <div class="task-status">
            <span>{{Math.trunc(task.no_of_task - task.number_of_task_accepted)}} {{$t('taskAvailable')}}</span>
            <span>{{task.no_of_task_completed}} {{$t('taskCompleted')}}</span>
          </div>

          <div class="text-link">
            <span>{{$t('viewetail')}}</span>
          </div>
        </div>
      </li>
      <infinite-loading @infinite="getAllTask">
        <template slot="no-more">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </ul>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import { mapGetters } from "vuex";
import types from "../store/types";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";

Vue.use(InfiniteLoading);

export default {
  name: "AllTaskList",
  data() {
    return {
      totalTask: 0,
      pageIndex: 0,
      allTaskList: [],
      loading: false
    };
  },
  components: {
    InfiniteLoading
  },
  methods: {
    goToDetail(id, family){
      console.log('===', id, family)
      if(family == "Local News"){
        this.registerReporter(id)
      }else{
        this.$router.push('/all-task-detail?allTaskIndex=' +id+'&success=null')
      }
    },
    registerReporter(id){
        ApiCaller(
        constant.BASE_API_URL,
        "tasks/localnews_registeration/",
        "get",
      ).then(data =>{
        console.log('==data all task=',data)
        if(data.eligibleFor){
          this.$router.push('/dashboard?allTaskIndex='+id)
        }else{
          this.$router.push('/sign-up?allTaskIndex='+id)
        }
      })
    },
    getAllTask($state) {
      // this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/alltasks/" + "?limit=" + this.pageIndex,
        "get"
      )
        .then(data => {
          // this.loading = false;
          if (data.data.length) {
            this.pageIndex += 1;
            this.allTaskList.push(...data.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.totalTask = data.total_task;
        })
        .catch(err => {
          // this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {
    // if (SessionHelper.getCookie(X_AUTH_ID)) {
    //   this.getAllTask();
    // }
  }
};
</script>